import { useEffect, RefObject } from 'react';

/**
 * Canvas GPU 内存管理 Hook
 *
 * 页面离开可见范围时，主动将 canvas 尺寸设为 0，立即释放 GPU IOSurface 纹理内存。
 * 这是防止 iOS Safari WebKit IOSurface 进程预算耗尽导致白屏崩溃的核心防御措施。
 *
 * visible 恢复为 true 时，usePdfRenderer 的 render effect 会重新设置 canvas 尺寸并重渲染。
 */
export function usePdfCanvasManager(
    canvasRef: RefObject<HTMLCanvasElement>,
    visible: boolean,
): void {
    useEffect(() => {
        if (!visible) {
            const canvas = canvasRef.current;
            if (canvas) {
                canvas.width = 0;
                canvas.height = 0;
            }
        }
    }, [visible, canvasRef]);
}
